module.exports = __webpack_public_path__ + "img/login-bg.796d9b11.png";